import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { Stack } from '../Stack';

export const PageText = styled.div`
    ${getTextTokenPreset('BODY_L_STRONG')};
`;

export const OverflowedContainer = styled.div`
    ${getTextTokenPreset('BODY_L_STRONG')};
    text-align: center;
    min-width: ${({ theme }) => theme.designTokens.SIZING_400}px;
`;

export const GhostIconButton = styled(IconButton)`
    background-color: transparent;
    color: ${({ theme }) => theme.designTokens.TEXT_STATIC_PRIMARY};

    &:focus-visible {
        box-shadow: ${({ theme }) => theme.designTokens.FOCUS_OFFSET};
        outline: none;
    }

    &:disabled {
        background-color: transparent;
        color: ${({ theme }) => theme.designTokens.TEXT_DISABLED};
    }

    &:hover:not([disabled]) {
        background-color: ${({ theme }) => theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER};
    }

    &:active:enabled {
        background-color: ${({ theme }) => theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE};
    }
`;

export const SquareButton = styled(Button)`
    background-color: transparent;
    padding: ${({ theme }) => theme.designTokens.SPACING_0}px;
    min-width: 32px;
    margin: ${({ theme }) => theme.designTokens.SPACING_25}px;
    color: ${({ theme }) => theme.designTokens.TEXT_STATIC_SECONDARY};

    &:focus-visible {
        box-shadow: ${({ theme }) => theme.designTokens.FOCUS_OFFSET};
        background-color: ${({ theme }) => theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER};
        outline: none;
    }

    &:disabled {
        opacity: ${({ theme }) => theme.designTokens.OPACITY_1000};
        color: ${({ theme }) => theme.designTokens.TEXT_STATIC_PRIMARY};
        border: ${getToken(TokenName.BORDER_WIDTH_150)}px ${getToken(TokenName.BORDER_STYLE_SOLID_STYLE)}
            ${getToken(TokenName.BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_DEFAULT)};
    }

    &:hover:not([disabled]) {
        background-color: ${({ theme }) => theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER};
    }

    &:active:enabled {
        background-color: ${({ theme }) => theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE};
    }
`;

export const MenuWrapper = styled(Stack)`
    margin: 0;
    padding: 0;
    list-style: none;
`;

SquareButton.defaultProps = {
    variant: 'ghost',
};
